module.exports = __webpack_public_path__ + "static/media/krizova-chodba-kriz.1e1558c2.jpg";